import React, { useState, useCallback, useRef } from "react";
import { Row, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setImportPreview } from "../../../../slices/vendorInvoices/reducer";
import { vendorInvoiceAPI } from "../../../../helpers/api/vendorInvoice";
import ImportModal from "./ImportModal";

const UploadSection = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const [modalOpen,   setModalOpen]   = useState(false);
  const [isDragOver,  setIsDragOver]  = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFile = useCallback(async (file) => {
    if (!file) return;
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await vendorInvoiceAPI.previewImport(formData);
      if (response.success) { dispatch(setImportPreview(response)); setModalOpen(true); }
      else toast.error(response.error || "Failed to parse file");
    } catch (err) {
      toast.error(err.message || "Failed to upload file");
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [dispatch]);

  return (
    <>
      <ImportModal open={modalOpen} onClose={() => setModalOpen(false)} onSuccess={onSuccess} />
      <Row className="g-4 mb-5">
        <Col lg={12}>
          <div className="bg-white rounded-3 p-4 shadow-sm border" style={{ minHeight: 280 }}>
            <div className="d-flex justify-content-between align-items-start mb-4">
              <div>
                <h5 className="fw-bold mb-1" style={{ color: "#002045" }}>Upload Vendor Invoices</h5>
                <p className="text-muted small mb-0">Batch process your incoming vendor documentation via intelligent ingestion.</p>
              </div>
              <div className="d-flex gap-2">
                <span className="badge bg-light text-dark border fw-bold" style={{ fontSize: "0.6rem", letterSpacing: "0.05em" }}>XLSX</span>
                <span className="badge bg-light text-dark border fw-bold" style={{ fontSize: "0.6rem", letterSpacing: "0.05em" }}>CSV</span>
              </div>
            </div>
            <input ref={fileInputRef} type="file" accept=".xlsx,.xls" style={{ display: "none" }} onChange={(e) => handleFile(e.target.files[0])} />
            <div
              className="border border-2 rounded-3 p-5 text-center"
              style={{ borderStyle: "dashed", borderColor: isDragOver ? "#002045" : "#dee2e6", background: isDragOver ? "#f0f4ff" : "transparent", cursor: isUploading ? "wait" : "pointer", transition: "all 0.2s", opacity: isUploading ? 0.7 : 1 }}
              onClick={() => !isUploading && fileInputRef.current?.click()}
              onDragOver={(e) => { e.preventDefault(); if (!isUploading) setIsDragOver(true); }}
              onDragLeave={() => setIsDragOver(false)}
              onDrop={(e) => { e.preventDefault(); setIsDragOver(false); handleFile(e.dataTransfer.files[0]); }}
            >
              <div className="d-flex justify-content-center mb-3">
                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 64, height: 64, background: "#dce8ff" }}>
                  {isUploading ? <div className="spinner-border spinner-border-sm" style={{ color: "#002045" }} role="status" /> : <i className="ri-upload-2-line fs-2" style={{ color: "#002045" }} />}
                </div>
              </div>
              <h6 className="fw-bold mb-1" style={{ color: "#002045" }}>{isUploading ? "Parsing file..." : "Drag and drop files here"}</h6>
              <p className="text-muted small mb-4">or click to browse your local directory</p>
              <button type="button" className="btn btn-outline-secondary btn-sm fw-bold px-4" disabled={isUploading} onClick={(e) => { e.stopPropagation(); fileInputRef.current?.click(); }}>Select Files</button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default UploadSection;
